export default {
  name: 'project-template-controls',
  inject: [
    '$currentUser',
    '$utils',
    '$signedInUserInfo'
  ],
  props: {
    currentScreenIndex: {
      type: Number,
      required: true
    },
    overlayProperties: {
      type: Object,
      required: true,
      validator (value) {
        return 'isVisible' in value && 'isDisabled' in value
      }
    },
    projectPages: {
      type: Object,
      required: true,
      validator (value) {
        return 'allPages' in value && 'allowedPages' in value
      }
    },
    visible: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
    }
  },
  computed: {
    currentPageNumber () {
      if (this.projectPages.allowedPages.length < 1) {
        return 0
      }

      return this.projectPages.allowedPages.findIndex((p) => p.uid === this.projectPages.allPages[this.currentScreenIndex].uid)
    },
    isPlanDiscovery () {
      return this.$signedInUserInfo?.activePlan?.name === this.$utils.options.plans.DISCOVERY
    },
    isUserLimited () {
      return this.$currentUser.hasGroupUserLimited()
    }
  },
  methods: {
    handleAddProjectPage (data) {
      this.$emit('page-change', { action: 'ADD_NEW_PAGE', payload: { data } })
    },
    handlePageChange (adjustment) {
      const nextPage = this.projectPages.allowedPages[this.currentPageNumber + adjustment]
      const nextPageNumber = this.projectPages.allPages.findIndex(p => p.uid === nextPage.uid)

      this.$emit('page-change', { action: 'NEW_PAGE_SELECTED', payload: { data: { pageNumber: nextPageNumber } } })
    },
    handleAddAppsOverlayClick () {
      this.$emit('overlay-click')
    }
  }
}
